const getIntercomResponse = (rawData: any) => {
  const { data: { data: { attributes = {} } = {} } = {} } = rawData
  return {
    ...attributes,
  }
}

const librariesFormattedResponses = {
  getIntercomResponse,
}

export default librariesFormattedResponses
